import Swiper from 'swiper';

class SingleSlider {
  constructor() {
    this.component = document.querySelector(
      '[data-component="home-event-slider"]'
    );
    this.trigger = document.querySelector('[data-trigger="home-event-slider"]');
    this._init();
  }

  _init() {
    if (this.component && this.trigger) {
      let mySwiper = null;
      mySwiper = new Swiper(this.trigger, {
        slidesPerView: 'auto',
        spaceBetween: 30,
        preventClicks: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        lazy: {
          loadOnTransitionStart: true
        }
      });

      // mySwiper.on("slideChange", function() {
      //   var activeIndex = this.activeIndex;
      //   var realIndex = this.slides.eq(activeIndex);
      //   var el = realIndex[0].childNodes;
      //   // el.classList.add("card-home-event__first");
      //   console.log(el);
      // });
    }
  }
}

export const singleSlider = new SingleSlider();
